<div *ngIf="authoringContentData" id="managePopUp">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{authoringContentData?.simChangeTitle}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <div class="row">

        <div *ngIf="!esimEnabled" class="col-12 col-sm-6 mb-4">
          <img class="sim_image" [src]="simImage" alt="SIM number" />
        </div>
        <div *ngIf="!esimEnabled"class="col-12 col-sm-6">
          <p>{{authoringContentData?.headerContentFirst}}</p>
          <p>{{authoringContentData?.headerContentSecond}}</p>
        </div>
        <div class="row helpText" *ngIf="esimEnabled">
          {{authoringContentData?.changeSimHelperTxt1}}
        </div>
        <div class="row helpText" *ngIf="esimEnabled">
          <strong>{{authoringContentData?.changeSimHelperTxt2}}</strong>
        </div>
      </div>
      <div *ngIf="!isMultiLineType">
        <div class="row">
          <div class="col-12">
            <h6 class="single-sim-swap-header">{{activeLines[indexZero].msisdn}}</h6>
          </div>
        </div>
        <app-sim-change-form [msisdn]="activeLines[indexZero].msisdn" [oldSim]="activeLines[indexZero].OldSim" [lineType]="isMultiLineType" (submitChangeValue)='visibleSubmitButton($event)'
          [reasons]="reasons" [finalConfirmation]="failedFlag" (eSimBtnClicked)="selectedSimType($event)">
        </app-sim-change-form>
      </div>
      <div *ngIf="isMultiLineType">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 tmo-numberOfLines">
            <h3>{{ activeLines.length }} {{ authoringContentData?.lineSelectedTxt }}</h3>
          </div>
        </div>
        <br>
        <mat-accordion *ngFor="let sline of activeLines; let i=index;" [ngClass]="{'expandedBody': (esimEnabled)}">
          <mat-expansion-panel [expanded]="sline.expendFlagValue" [ngClass]="{'expandedBody': (esimEnabled)}" (closed)="expansionPanelClosed(sline)" (opened)="expansionPanelOpened(sline)">
            <mat-expansion-panel-header (click)="manageLineService.setStep(i)" class="specific-class" [ngClass]="{'expandedBody': (esimEnabled)}">
              <mat-panel-title class="accordion-txt">
                <span class="validIcon" *ngIf="(submitNextValue[i]?.newSim?.length == lengthNineteen || submitNextValue[i]?.newSim?.length == lengthTwenty || (esimEnabled && submitNextValue[i]?.eid?.length == 32))"></span>
                {{sline?.msisdn}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-sim-change-form [ngClass]="{'expandedBody': (esimEnabled)}" [msisdn]="sline.msisdn" [oldSim]="sline.OldSim" [lineType]="isMultiLineType" (submitNextValue)='visibleNextButton($event)'
              [reasons]="reasons" [multiSimChange]="multiSimChange"></app-sim-change-form>
            <button (click)="nextStep(sline)" type="button" class="btn primary_btn" *ngIf="activeLines.length > lengthOne"
              [disabled]="!(submitNextValue[i]?.newSim?.length == lengthNineteen || submitNextValue[i]?.newSim?.length == lengthTwenty || (esimEnabled && submitNextValue[i]?.eid?.length == 32))">{{authoringContentData?.nextTxt}}</button>
            <a *ngIf="activeLines.length > lengthOne" class="remove_number_link small-pink" (click)="removeNumber(sline, submitNextValue[i])">{{authoringContentData?.removeNumberTxt}}</a>
          </mat-expansion-panel>
          <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
        </mat-accordion>
      </div>
    </div>
  </div>
  <!--Profile override check box for care users-->
  <div class="row profileCheck align-items-baseline" *ngIf="authType_okta && !isMultiLineType && esimEnabled && eSimSelected">
    <div class="col-1 col-sm-1 col-lg-1 col-md-1">
        <div class="checkbox checkbox-primary">
            <mat-checkbox id='termscheckbox' class="padding-checkbox" (change)="enableProfileOverride($event)"></mat-checkbox>
            <label for="termsCheckbox"> </label>
        </div>
    </div>
    <div class= "col-11 col-sm-11 col-lg-11 col-md-11">
      <div class=" profileOverrideTxt1">
        {{authoringContentData?.oktaProfileOverrideTxt}}
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row mx-0">
      <div class="col-12 col-sm-12 col-md-6 mb-4">
        <button type="button" class="btn primary_btn w-100" (click)="simChangeNumber()" [disabled]="!submitChangeValue || isSubmitReadOnly">
          {{authoringContentData?.submitChangeTxt}}
        </button>
      </div>
      <div class="col-12 col-sm-12 col-md-6" *ngIf="submitChangeValue">
        <div class="change-content-sim" *ngIf="activeLines.length === lengthOne">
          <p class="head">{{ authoringContentData?.singleRequestTxt }}</p>
          <p class="content">{{authoringContentData?.simChangeConfirm }}</p>
          <p class="head">{{ authoringContentData?.advisements }}</p>
          <p class="content">{{ authoringContentData?.serviceNoteTxt }}</p>
        </div>
        <div class="change-content-sim" *ngIf="activeLines.length > lengthOne">
          <p class="head">{{ authoringContentData?.multipleRequestTxt }}</p>
          <p class="head">{{ authoringContentData?.advisements }}</p>
          <p class="content">{{ authoringContentData?.serviceNoteTxt }}</p>
        </div>
      </div>
    </div>
  </div>
</div>